import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "header" }
const _hoisted_4 = {
  key: 0,
  class: "name"
}
const _hoisted_5 = { class: "ratingAndLink" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 2,
  class: "links"
}
const _hoisted_8 = { class: "link" }
const _hoisted_9 = { class: "link" }
const _hoisted_10 = { class: "scores" }
const _hoisted_11 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_artist_rating = _resolveComponent("artist-rating")!
  const _component_external_link = _resolveComponent("external-link")!
  const _component_value_slider = _resolveComponent("value-slider")!
  const _component_flag_label = _resolveComponent("flag-label")!
  const _component_plus_icon = _resolveComponent("plus-icon")!
  const _component_metric_selector = _resolveComponent("metric-selector")!
  const _component_loading_icon = _resolveComponent("loading-icon")!
  const _component_check_icon = _resolveComponent("check-icon")!
  const _component_cross_icon = _resolveComponent("cross-icon")!
  const _component_edit_icon = _resolveComponent("edit-icon")!
  const _component_sliders_icon = _resolveComponent("sliders-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.localArtist.imageUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.localArtist.imageUrl,
          class: "artistImage"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "artistImage",
          style: _normalizeStyle({ 'background-color': _ctx.darkColor })
        }, null, 4)),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.localArtist.name), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "input name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localArtist.name) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.localArtist.name]
          ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_artist_rating, {
          modelValue: _ctx.rating,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rating) = $event)),
          color: _ctx.darkColor,
          active: _ctx.editing,
          style: {"margin-right":"20px"}
        }, null, 8, ["modelValue", "color", "active"]),
        (!_ctx.editing)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.localArtist.linkUrl ?? '',
              target: "_blank",
              class: "link"
            }, [
              _createVNode(_component_external_link, {
                height: "32",
                width: "32"
              })
            ], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "link" }, "Image URL", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input link",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localArtist.imageUrl) = $event))
            }, null, 512), [
              [_vModelText, _ctx.localArtist.imageUrl]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "link" }, "Link URL", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input link",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localArtist.linkUrl) = $event))
            }, null, 512), [
              [_vModelText, _ctx.localArtist.linkUrl]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.scores).sort((a, b) => a.metric.category.localeCompare(b.metric.category)), (score) => {
        return (_openBlock(), _createElementBlock("div", {
          key: score.metric.name + score.rerender,
          class: "score"
        }, [
          (_ctx.isValue(score))
            ? (_openBlock(), _createBlock(_component_value_slider, {
                key: 0,
                modelValue: score.values,
                "onUpdate:modelValue": ($event: any) => ((score.values) = $event),
                color: score.metric.color,
                label: score.metric.name,
                active: _ctx.editing,
                onDiscardMetric: ($event: any) => (_ctx.removeScore(score))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "label", "active", "onDiscardMetric"]))
            : (_openBlock(), _createBlock(_component_flag_label, {
                key: 1,
                style: {"margin-top":"10px"},
                label: score.metric.name,
                color: score.metric.color,
                active: _ctx.editing,
                onDiscardMetric: ($event: any) => (_ctx.removeScore(score))
              }, null, 8, ["label", "color", "active", "onDiscardMetric"]))
        ]))
      }), 128)),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button edit",
            style: {"margin-top":"8px"},
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleMetricsPanel && _ctx.toggleMetricsPanel(...args))),
            title: "Add Score"
          }, [
            _createVNode(_component_plus_icon, {
              height: 28,
              width: 28
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.editing && _ctx.metricsPanelActive)
      ? (_openBlock(), _createBlock(_component_metric_selector, {
          key: 3,
          width: "400px",
          color: _ctx.color,
          metrics: _ctx.selectionMetrics,
          allowNewMetric: true,
          onMetricSelected: _ctx.addOrEditScore,
          onMetricUnselected: _ctx.removePanelScore,
          onClickOutside: _ctx.toggleMetricsPanel
        }, null, 8, ["color", "metrics", "onMetricSelected", "onMetricUnselected", "onClickOutside"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button confirm",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args))),
            title: "Confirm Changes"
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_loading_icon, {
                  key: 0,
                  height: 28,
                  width: 28
                }))
              : (_openBlock(), _createBlock(_component_check_icon, {
                  key: 1,
                  height: 28,
                  width: 28
                }))
          ]))
        : _createCommentVNode("", true),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "button discard",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleEdit && _ctx.toggleEdit(...args))),
            title: "Discard Changes"
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_loading_icon, {
                  key: 0,
                  height: 28,
                  width: 28
                }))
              : (_openBlock(), _createBlock(_component_cross_icon, {
                  key: 1,
                  height: 28,
                  width: 28
                }))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "button edit",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleEdit && _ctx.toggleEdit(...args))),
            title: "Edit Artist"
          }, [
            _createVNode(_component_edit_icon, {
              height: 26,
              width: 26
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "button edit",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.artistsLikeThis && _ctx.artistsLikeThis(...args))),
            title: "Artists like this"
          }, [
            _createVNode(_component_sliders_icon, {
              height: 26,
              width: 26
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}